import axios from 'axios';
import {ENDPOINT} from 'constants';

const BASE_URL = `${ENDPOINT}api/v1/admin-ops/activity-logs`;

const authHeaders = accessToken => ({
  headers: {Authorization: `Bearer ${accessToken}`},
});

// Read-only audit trail — backend exposes no create/update/delete endpoints for this resource.
export const activityLogsApi = {
  fetchLogs: async (accessToken, params = {}) => {
    const {data} = await axios.get(BASE_URL, {
      ...authHeaders(accessToken),
      params,
    });
    return data?.data;
  },

  fetchLogById: async (accessToken, id) => {
    const {data} = await axios.get(`${BASE_URL}/${id}`, authHeaders(accessToken));
    return data?.data;
  },
};
